import { getInterview } from "../../services/interviewActions/interviewService";
import { useNavigate } from "@solidjs/router";
import { getAzureToken } from "../../services/interviewActions/interviewService";
import { deleteInterview } from "../../services/interviewActions/deleteInterviewService";
import trash from "../../assets/trash.svg";
import {
  userEmail,
  userInterviews,
  setUserInterviews,
  setUserFeedback,
  setInterview,
  interview,
} from "../../stores/userStore";
import { createSignal } from "solid-js";
import { fetchFeedback } from "../../services/interviewActions/interviewService";
import Loading from "../Loading";

export default function PrevInterview({ id, name, date, thisInterview }) {
  const formatDate = new Date(date);
  const nav = useNavigate();
  const [loading, setLoading] = createSignal(false);
  const [hovering, setHovering] = createSignal(false);

  const handleClick = async () => {
    if (!interview()) {
      setInterview(thisInterview);
    }

    if (thisInterview.status === 0) {
      setLoading(true);
      const feedback = await fetchFeedback(thisInterview.feedback_id);
      console.log(feedback);
      setUserFeedback(feedback);
      setLoading(false);
      nav(`/feedback/${thisInterview.feedback_id}`);
    } else {
      setLoading(true);
      setInterview(thisInterview);
      await getAzureToken();
      setLoading(false);
      nav(`/interview/${id}`);
    }
  };

  const handleDelete = async (e) => {
    e.stopPropagation();

    try {
      await deleteInterview(userEmail(), id);
      const newUserInterviews = (userInterviews() || []).filter(
        (i) => i._id !== id,
      );
      setUserInterviews([...newUserInterviews]);
    } catch (error) {
      console.error("Delete failed:", error?.message || error);
    }
  };

  return (
    <div>
      <div
        className="prev-interview"
        onClick={handleClick}
        onMouseEnter={() => setHovering(true)}
        onMouseLeave={() => setHovering(false)}>
        <div className="content-container">
          <div className="prev-interview-header">
            <p className="interview-date">
              {formatDate.toLocaleDateString("en-US", {
                year: "numeric",
                month: "short",
                day: "2-digit",
              })}
            </p>
            <Show when={hovering()}>
              <button className="trash-button" onClick={handleDelete}>
                <img className="trash-icon" src={trash} alt="Delete" />
              </button>
            </Show>
          </div>
          <p className="interview-name">{name}</p>
        </div>
      </div>
      <Loading show={loading()} />
    </div>
  );
}
